import { render } from "./LibraryPage.vue?vue&type=template&id=1242e58c&scoped=true"
import script from "./LibraryPage.vue?vue&type=script&lang=js"
export * from "./LibraryPage.vue?vue&type=script&lang=js"

import "./LibraryPage.vue?vue&type=style&index=0&id=1242e58c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1242e58c"]])

export default __exports__